import { httpClient, ApiResponse } from '@/utils';
import {
  AdminsEndpoints,
  IAdminProfileResponse,
  IAdminProfileDTO,
  IChangePasswordDTO,
  IManagersListResponse,
} from '@/models/admins.model';

class AuthAPI {
  static getAdminProfile(): ApiResponse<IAdminProfileResponse> {
    return httpClient.get<IAdminProfileResponse>(AdminsEndpoints.PROFILE);
  }

  static updateAdminProfile(data: IAdminProfileDTO): ApiResponse<IAdminProfileResponse> {
    return httpClient.patch<IAdminProfileResponse>(AdminsEndpoints.PROFILE, data);
  }

  static changePassword(data: IChangePasswordDTO): ApiResponse<IAdminProfileResponse> {
    return httpClient.post<IAdminProfileResponse>(AdminsEndpoints.CHANGE_PASSWORD, data);
  }

  static getManagersList(): ApiResponse<IManagersListResponse> {
    // The backend owns the allow-list of assignable order-manager roles
    // (client_service_head + client_manager) — no role params needed here.
    return httpClient.get<IManagersListResponse>(AdminsEndpoints.ORDER_MANAGERS);
  }
}

export default AuthAPI;
